import React from "react";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

interface StateReportDocumentViewerModalProps {
  open: boolean;
  onClose: () => void;
  fileName: string | null;
  loading: boolean;
  viewerUrl: string | null;
}

export const StateReportDocumentViewerModal: React.FC<
  StateReportDocumentViewerModalProps
> = ({ open, onClose, fileName, loading, viewerUrl }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="lg"
    fullWidth
    PaperProps={{
      sx: {
        width: "90%",
        maxHeight: "90vh",
        borderRadius: 2,
        boxShadow: "0 24px 48px rgba(0,0,0,0.12)",
        overflow: "hidden",
      },
    }}
    sx={{ zIndex: 1600, "& .MuiDialog-paper": { overflow: "hidden" } }}
  >
    <DialogTitle
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        py: 2,
        px: 3,
        background: "linear-gradient(135deg, #0d4a63 0%, #15607a 100%)",
        color: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          flex: 1,
          minWidth: 0,
        }}
      >
        <DescriptionOutlinedIcon sx={{ fontSize: 24, opacity: 0.95 }} />
        <Typography
          component="span"
          variant="h6"
          sx={{
            fontWeight: 600,
            letterSpacing: "0.02em",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {fileName || "Document"}
        </Typography>
      </Box>
      <IconButton
        onClick={onClose}
        sx={{
          color: "rgba(255,255,255,0.9)",
          "&:hover": {
            color: "#fff",
            backgroundColor: "rgba(255,255,255,0.12)",
          },
        }}
        aria-label="Close"
      >
        <CloseOutlinedIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent
      dividers
      sx={{ padding: 0, height: "80vh", position: "relative" }}
    >
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : viewerUrl ? (
        <Box sx={{ width: "100%", height: "100%" }}>
          <iframe
            src={viewerUrl}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
            title="Document Viewer"
          />
        </Box>
      ) : null}
    </DialogContent>
  </Dialog>
);
